exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.navigation-container[data-v-5642e415]{\n  text-align: center;\n}\nh1[data-v-5642e415]{\n  padding-top: 40px;\n}\n", "", {"version":3,"sources":["/var/lib/jenkins/workspace/tms-docker-build@2/frontend/shipper/src/components/modules/menuNavigator.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;CACpB;AACD;EACE,kBAAkB;CACnB","file":"menuNavigator.vue","sourcesContent":["\n.navigation-container[data-v-5642e415]{\n  text-align: center;\n}\nh1[data-v-5642e415]{\n  padding-top: 40px;\n}\n"],"sourceRoot":""}]);

// exports
